import { Modal } from 'antd';
import { PureComponent, ReactNode } from 'react';
import { backArrowIcon, closeIcon } from '../../../../common/Icons';
import { CareCanvasTemplate } from '../../../../../store/types/CareCanvas';

type Props = {
    closeMe: () => void;
    template?: CareCanvasTemplate;
    applyTemplate?: (template: CareCanvasTemplate) => void;
};

class PreviewTemplateModal extends PureComponent<Props> {
    closeIcon = closeIcon('w-12 h-12 fill-darwin-neutral-1000');
    backArrow = backArrowIcon();

    render(): ReactNode {
        const { closeMe, template, applyTemplate } = this.props;
        const { closeIcon, backArrow } = this;

        return (
            <Modal
                bodyStyle={{
                    padding: '0px',
                }}
                visible={Boolean(template)}
                width={600}
                onCancel={closeMe}
                footer={null}
                closable={false}
                destroyOnClose
            >
                {template && (
                    <div className="flex flex-col bg-darwin-neutrals-50 overflow-hidden text-13">
                        <div className="px-16 py-12 flex items-center justify-between border-b border-darwin-neutral_new-200 bg-white">
                            <div className="flex items-center space-x-16">
                                <button
                                    onClick={closeMe}
                                    className="flex items-center justify-center w-16 h-16"
                                >
                                    {backArrow}
                                </button>
                                <p className="text-20">{template.name}</p>
                            </div>
                            <button className="p-6" onClick={closeMe}>
                                {closeIcon}
                            </button>
                        </div>
                        <div className="flex-1 min-h-200 max-h-504 flex justify-center p-16 overflow-auto">
                            <img className="max-h-full" src={template.final_image} />
                        </div>

                        <div
                            className={`w-full px-16 py-12 flex items-center ${
                                applyTemplate ? 'justify-between' : 'justify-end'
                            } border-t border-darwin-neutral_new-200 bg-white`}
                        >
                            <button
                                className="font-700 text-darwin-accent-bright-blue-800"
                                onClick={closeMe}
                            >
                                Cancel
                            </button>
                            {applyTemplate && (
                                <button
                                    className="primary-btn-v3 btn--small flex items-center space-x-8 px-16 py-8 disabled:opacity-70 disabled:cursor-not-allowed"
                                    onClick={() => {
                                        applyTemplate(template);
                                        closeMe();
                                    }}
                                >
                                    Apply
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        );
    }
}

export default PreviewTemplateModal;
